import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from 'axios';
import { CompanyBranchBlockUnblockValidationSchema } from "../schemas/blockUnblockCompanyBranch.schema";

interface UseBlockClientCompanyBranchProps {
  companyBranchId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useBlockClientCompanyBranch = ({ companyBranchId, onSuccess, onError }: UseBlockClientCompanyBranchProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, CompanyBranchBlockUnblockValidationSchema>({
    mutationKey: ['blockClientCompanyBranch', companyBranchId],
    mutationFn: async (data) => {
      await privateAxios.put(`/client/company_branches/${companyBranchId}/disable`, {
        company_branch: data,
      });
    },
    onSuccess,
    onError,
  });
};

export default useBlockClientCompanyBranch;

